import React, { createContext, useContext } from 'react';

interface BoardContextType {
    triggerSaveBoard: (immediate?: boolean) => void;
}

const BoardContext = createContext<BoardContextType | undefined>(undefined);

export const useBoard = () => {
    const context = useContext(BoardContext);
    if (!context) {
        throw new Error('useBoard must be used within a BoardProvider');
    }
    return context;
};

export const BoardProvider: React.FC<{ value: BoardContextType; children: React.ReactNode }> = ({ value, children }) => {
    return <BoardContext.Provider value={value}>{children}</BoardContext.Provider>;
};
